import { createSelector } from "reselect";

export const getComponents = state => state.page.components;
export const getState = state => state;

export const getSections = state =>
  state.page.components.filter(i => !i.parent_id);

export const findByFather = (state, id) =>
  state.filter(i => i.parent_id === id);

export const findElement = (state, key) =>
  getComponents(state).find(i => i.key === key);

export const findByComponentName = (state, name) =>
  state.filter(i => i.component === name);

export const findNextColumn = (state, sectionId, columnId) => {
  const columns = findByFather(state.page.components, sectionId).sort(
    (a, b) => a.props.position - b.props.position
  );
  const columnIndex = columns.findIndex(col => col.key === columnId);
  return columns[columnIndex + 1];
};

export const findHoveringElement = createSelector(
  state => state.editor.hoveringElement,
  getComponents,
  (key, components) => components.find(c => c.key === key)
);

export const getOrderedSections = createSelector(getSections, sections => {
  return sections.sort((a, b) => a.position - b.position);
});

export const getOrderedElements = createSelector(findByFather, elements => {
  return elements.sort((a, b) => a.position - b.position);
});

export const getMountElements = createSelector(
  [getOrderedElements, getState],
  (elements, components) => {
    return elements.map(e => {
      e.components = getOrderedElements(components, e.key);
      return e;
    });
  }
);
